import React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Admin from "./admin/Admin";
import Footer from "./components/Footer";
import CourseOne from "./pages/CourseOne";
import CourseTwo from "./pages/CourseTwo";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UserLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
);




function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<UserLayout />}>
          <Route index element={<Home />} />
          <Route path="one-year-course" element={<CourseOne />} />
          <Route path="short-term-course" element={<CourseTwo />} />
        </Route>
   
      </Routes>
    </Router>
  );
}

export default App;
